<template>
  <section class="container howtouse mb-18 distance">
    <div class="row">
      <div class="col-md-6 howtouse--img-wrap"><img src="@/assets/images/main/htu.jpg" class="howtouse--img" alt="calming balance gel, dermatology serum, active cream, active clean-up power"></div>
      <div class="col-md-6 howtouse--txt">
        <h2 class="howtouse--tit mb-6"><strong>How to</strong> Use</h2>
        <p class="howtouse--p1 distance">작은 디테일의 차이가<span class="brs"></span>
          드라마틱한 <span class="mbr"></span> <span class="txt-st">변화의 기초</span>가 됩니다.</p>
        <p class="mb-8">피부 타입에 따른 최적의<span class="brs"></span>
          사용 방법 확인이 중요합니다.</p>
        <a href="" class="btn-st02" @click.prevent="$router.push('/howtouse')">사용방법 알아보기</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HowToUse',
};
</script>
